module.exports = __webpack_public_path__ + "static/fonts/RuiZiZhenYanTiMianFeiShangYong-2.1583afec.ttf";